import React, { useState } from 'react'
import getImageUrl from '../functions/getImageUrl'

const BackgroundImage = ({image, isMobile}) => {
    const [fallbackInUse, setFallback] = useState(false)
    const {finalImageURl, imageUrl, position} = getImageUrl(image, isMobile, false, true)
    let styles = {    
        objectPosition: position,
        width: '100%'
    }

    return <img 
            src={finalImageURl} 
            style={styles}
            className={'movie-item-background-image theme-radius-posters-full backgrounds'}
            alt={'Background'} 
            onError={({ currentTarget }) => {
                if(fallbackInUse) {
                    currentTarget.onerror = null; 
                    currentTarget.src = '';
                } else {
                    setFallback(true)
                    currentTarget.onerror = null; 
                    currentTarget.src = imageUrl;
                }
            }}
        />
}

export default BackgroundImage